import { Component, computed, inject, input } from '@angular/core';
import { GenericLinkDirective } from '@core/jss-utils';
import { ReviewStatistics } from '@integration/reviews-api-models';
import { CoreJssProxyModule } from '@core/jss-proxy';
import { NgTemplateOutlet } from '@angular/common';
import { DeployUrlPipe } from '@innogy/utils/environment';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { CrntButtonAlt, CrntIcon } from '@essent/current-web-angular';
import { TranslatePipe } from '@ngx-translate/core';

import { ReviewStarsComponent } from '../review-stars/review-stars.component';
import {
  ReviewsComponentRendering,
  ReviewScoreWidgetType,
} from '../reviews.model';

@Component({
  selector: 'wl-review-score',
  templateUrl: './review-score.component.html',
  standalone: true,
  styleUrls: [
    './review-score.component.ed.scss',
    './review-score.component.essent.scss',
  ],
  imports: [
    CoreJssProxyModule,
    ReviewStarsComponent,
    NgTemplateOutlet,
    GenericLinkDirective,
    DeployUrlPipe,
    CrntButtonAlt,
    TranslatePipe,
    CrntIcon,
  ],
})
export class ReviewScoreComponent {
  readonly rendering = input.required<ReviewsComponentRendering>();
  readonly stats = input.required<ReviewStatistics>();
  readonly type = input<ReviewScoreWidgetType>('small');
  readonly showCard = input(true);

  readonly env = inject(ENVIRONMENT_CONFIG);

  readonly brand = this.env.brand === 'essent' ? 'Essent' : 'Energiedirect';

  readonly fields = computed(() => this.rendering().fields);
  readonly title = computed(() => this.fields()?.Title);
  readonly showTitle = computed(() => !!this.title()?.value);
  readonly logoSize = computed<'small' | 'large'>(() =>
    this.type() === 'overview' ? 'large' : 'small'
  );
}
